import React from 'react'
import Link from 'next/link'

import { routes } from '../../routes'
import styles from './styles.module.scss'

const TermsOfServiceText: React.FC = () => {
  return (
    <p className={styles.p}>
      By continuing, you agree to our{' '}
      <Link href={routes.termsOfUse}>
        <a rel="noopener" target="_blank">
          Terms of Use
        </a>
      </Link>{' '}
      and{' '}
      <Link href={routes.privacyPolicy}>
        <a rel="noopener" target="_blank">
          Privacy Policy
        </a>
      </Link>
    </p>
  )
}

export default TermsOfServiceText
